import { createSlice } from "@reduxjs/toolkit";
import { creatSetState, mapBaseReducers } from "@/utils/reduxUtils";
import { User } from "@/types";
import { ISchool } from "@/services/school";
import { CourseScheduleRecord } from "@/services/courseScheduling/scheduleList";
import { ScheduleRuleSatisfaction } from "@/services/courseScheduling/settingRules";
import { ISchoolYear } from "@/services/schoolCalendar";

export interface UserState {
  isLogin: boolean;
  hasInit: boolean;
  userInfo?: User;
  school?: ISchool;
  scheduleScheme?: CourseScheduleRecord;
  customResolveNext: boolean;
  needResolveNext: boolean;
  hasScheduled: boolean;
  openLoginModal: boolean;
  accessPerms: string[];
  accessUrls: string[];
  userVipInfo?: any;
  scheduleRulesSatisfactionMap: Record<string, ScheduleRuleSatisfaction> | undefined;
  stepsIsExpanded?: boolean;
  shouldFocusSchedule: string | undefined;
  currentSchoolYear?: ISchoolYear
}

const initialState: UserState = {
  isLogin: false,
  hasInit: false,
  userInfo: undefined,
  school: undefined,
  scheduleScheme: undefined,
  customResolveNext: false, // 页面自行处理下一步逻辑
  needResolveNext: false, // 页面需要处理下一步逻辑
  hasScheduled: true, // 是否已经排课，默认为true不触发自动排
  openLoginModal: false, // 打开登录弹窗
  accessPerms: [], // 用户功能权限标识符列表
  accessUrls: [], // 用户页面权限标识符列表
  userVipInfo: undefined,
  scheduleRulesSatisfactionMap: undefined,
  stepsIsExpanded: true,
  shouldFocusSchedule: undefined,
  currentSchoolYear: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    ...mapBaseReducers(),
  },
});

export const setUserState = creatSetState("user");

export default userSlice;
